<script setup>
import { computed } from 'vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const options = computed(
  () =>
    props.attribute.attributeValues?.map(value => ({
      label: value,
      value,
    })) || []
);

const handleUpdate = value => emit('update', value);
</script>

<template>
  <div class="flex flex-col w-full gap-1">
    <span class="mb-0.5 text-heading-3 text-n-slate-12">
      {{ attribute.attributeDisplayName }}
    </span>
    <ComboBox
      :model-value="attribute.value"
      :options="options"
      :placeholder="attribute.placeholder || attribute.attributeDisplayName"
      class="w-full [&>div>button]:h-8 [&>div>button]:bg-n-alpha-black2 [&>div>button:not(.focused)]:!outline-transparent"
      @update:model-value="handleUpdate"
    />
  </div>
</template>
